import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --bgColor: ${brand.green};
  --fgColor: ${brand.white};
  --itemGap: 24px;
  --itemPadding: 11px;
  --itemSize: 24px;

  color: var(--fgColor);
  margin: ${fluid(32, 48)} 0 ${fluid(40, 48)};

  @media ${from(Device.Tablet)} {
    --itemGap: 16px;
  }
`;
const List = styled.ul `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--itemGap);
`;
const Item = styled.li ``;
const Link = styled.a `
  display: block;
  background-color: var(--bgColor);
  border: 0;
  border-radius: 50%;
  color: currentColor;
  margin: 0;
  padding: var(--itemPadding);
  text-decoration: none;
  transform: scale(1);
  ${transition('transform')};

  /* Enable focus styles for Safari */
  &:focus {
    outline: auto;
    outline-color: var(--bgColor);
    outline-offset: 5px;
    outline-width: thin;
  }

  /* Disable default focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: auto;
    outline-color: var(--bgColor);
    outline-offset: 5px;
    outline-width: thin;
  }

  /* Apply hover styles */
  &:hover {
    transform: scale(1.2);
  }
`;
const Icon = styled.span `
  display: block;
  height: var(--itemSize);
  color: currentColor;
  width: var(--itemSize);
`;
const SocialLinksStyles = {
    Container,
    Icon,
    Item,
    Link,
    List,
};
export default SocialLinksStyles;
